export default __webpack_public_path__ + "static/media/authentication-background.ee74acbd.jpg";